import { render, staticRenderFns } from "./autosuggest.vue?vue&type=template&id=4f7f153c&scoped=true&"
import script from "./autosuggest.vue?vue&type=script&lang=js&"
export * from "./autosuggest.vue?vue&type=script&lang=js&"
import style0 from "./autosuggest.vue?vue&type=style&index=0&id=4f7f153c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7f153c",
  null
  
)

export default component.exports